/** Account routes keep native chat identities intact; titles only describe the URL. */
const accountRoots = new Set(['workspace', 'agents', 'tasks', 'files', 'settings', 'billing']);
export function chatTitleSlug(title: string): string {
  return title.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 80).replace(/-$/, '') || 'work-chat';
}
export function accountLocation(pathname: string, search = '', base = '') {
  const relative = pathname.slice(base.length), parts = relative.split('/').filter(Boolean);
  const params = new URLSearchParams(search);
  if ((parts[0] === 'billing' || parts[0] === 'subscribe') && parts[1] === 'plans' && parts.length === 3 && /^[a-z0-9-]+$/.test(parts[2]!)) {
    params.set('plan', parts[2]!);
    return {pathname: `${base}/${parts[0]}`, search: `?${params}`, slug: null};
  }
  if (accountRoots.has(parts[0] ?? '') && parts[1] === 'chats' && parts[2] && parts[3]) {
    params.set('chat', decodeURIComponent(parts[3]));
    if (parts[4] === 'agents' && parts[5]) params.set('agent', decodeURIComponent(parts[5]));
    if (parts[4] === 'roles' && parts[5]) params.set('role', decodeURIComponent(parts[5]));
    return {pathname: `${base}/${parts[0]}`, search: `?${params}`, slug: parts[2]};
  }
  if (accountRoots.has(parts[0] ?? '') && parts[1] === 'roles' && parts[2]) {
    params.set('role', decodeURIComponent(parts[2]));
    return {pathname: `${base}/${parts[0]}`, search: `?${params}`, slug: null};
  }
  return {pathname, search, slug: null};
}
export function accountHref(href: string, base = '', title?: string): string {
  const url = new URL(href, 'https://account.invalid');
  if (url.origin !== 'https://account.invalid') return href;
  const location = accountLocation(url.pathname, url.search, base);
  if (/^\/(?:billing|subscribe)\/plans\//.test(url.pathname.slice(base.length))) return href;
  if (!accountRoots.has(location.pathname.slice(base.length + 1))) return href;
  const params = new URLSearchParams(location.search), chat = params.get('chat');
  const agent = params.get('agent'), role = params.get('role');
  let path = location.pathname;
  if (chat) path += `/chats/${title ? chatTitleSlug(title) : location.slug ?? 'work-chat'}/${encodeURIComponent(chat)}`;
  if (chat && agent) path += `/agents/${encodeURIComponent(agent)}`;
  else if (role) path += `/roles/${encodeURIComponent(role)}`;
  for (const field of ['chat', 'agent', 'role']) params.delete(field);
  return `${path}${params.size ? `?${params}` : ''}${url.hash}`;
}
